import { Box, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import PropTypes from "prop-types";

import { GREY, BRAND } from "../../styles/redesignTheme";

export const STORY_MAX_CHARS = 2000;

// Fields to merge into a log submission. Only sends the story when the student
// actually wrote one, so the API can skip the record + staff notification.
export function buildStoryPayload(story, consent) {
  const text = (story || "").trim();
  if (!text) return {};
  return { story: text, story_consent: Boolean(consent) };
}

// Optional "share your story" prompt shown when a student logs hours. SVA staff
// are notified when it's filled in, so they can use it for comms/socials.
export default function StoryPrompt({ story, consent, onStoryChange, onConsentChange }) {
  const length = (story || "").length;
  const hasStory = Boolean((story || "").trim());

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AutoAwesomeOutlinedIcon sx={{ fontSize: 20, color: BRAND.orange }} />
        <Typography sx={{ fontWeight: 600, color: GREY[800] }}>Share your story (optional)</Typography>
      </Box>
      <Typography variant="body2" sx={{ color: GREY[500] }}>
        Want to share something about your experience? We&apos;d love to hear it and share it with our partners and put it on our socials!
      </Typography>
      <TextField
        fullWidth
        multiline
        minRows={3}
        placeholder="e.g. A moment that stood out, someone you helped, or why this mattered to you"
        value={story || ""}
        onChange={(e) => onStoryChange(e.target.value.slice(0, STORY_MAX_CHARS))}
        inputProps={{ maxLength: STORY_MAX_CHARS }}
      />
      <Typography variant="caption" sx={{ color: GREY[400], alignSelf: "flex-end" }}>
        {length}/{STORY_MAX_CHARS}
      </Typography>
      {hasStory && (
        <FormControlLabel
          control={<Checkbox checked={Boolean(consent)} onChange={(e) => onConsentChange(e.target.checked)} sx={{ "&.Mui-checked": { color: BRAND.orange } }} />}
          label={
            <Typography variant="body2" sx={{ color: GREY[700] }}>
              I&apos;m happy for SVA to share my story (and first name) in newsletters, with partners and on social media.
            </Typography>
          }
        />
      )}
    </Box>
  );
}

StoryPrompt.propTypes = {
  story: PropTypes.string,
  consent: PropTypes.bool,
  onStoryChange: PropTypes.func.isRequired,
  onConsentChange: PropTypes.func.isRequired,
};

StoryPrompt.defaultProps = {
  story: "",
  consent: false,
};
